/**
 * 儀表板看板卡片外框：標題列（區域色）＋ 內容區（明亮白底）
 */
export default function DashboardCard({ title, color, children, noPadding = false }) {
  return (
    <div
      className="flex flex-col h-full overflow-hidden"
      style={{ borderRadius: 12, background: 'white', boxShadow: '0px 2px 12px rgba(110,98,91,0.12)' }}
    >
      <div className="flex items-center shrink-0" style={{ padding: '12px 22px', background: color }}>
        <span style={{ fontFamily: 'Noto Serif TC', fontSize: 28, fontWeight: 700, color: 'white', letterSpacing: '0.05em' }}>
          {title}
        </span>
      </div>
      <div className="flex-1 min-h-0" style={{ padding: noPadding ? 0 : 12 }}>
        {children}
      </div>
    </div>
  )
}
